<div class="media">
  <div class="media-body align-self-center">
    <div class="progress-bar shadow-internal" style="height: {{height}}px">
      <div class="bar bg-primary" [style.width]="getScore()"></div>
    </div>
  </div>
</div>
